/* RESPONSIBLE TEAM: team-standalone */

import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import { type FieldType } from 'embercom/objects/standalone/data-fields/common';
import { type IntercomFieldType } from 'embercom/models/standalone/external-field-identifier';

export interface TicketFieldResponse {
  id: string;
  name: string;
  description?: string;
  type: FieldType;
  required: boolean;
  createable?: boolean;
  updateable?: boolean;
  intercom_cvda?: {
    id: string;
  };
  built_in?: boolean;
}

export class TicketField {
  id: string;
  name: string;
  description?: string;
  type: FieldType;
  required: boolean;
  createable?: boolean;
  updateable?: boolean;
  @tracked isSynchronizing?: boolean = false;
  intercom_cvda?: {
    id: string;
  };
  builtIn: boolean;

  constructor(response: TicketFieldResponse) {
    this.id = response.id;
    this.name = response.name;
    this.description = response.description;
    this.type = response.type;
    this.required = response.required;
    this.intercom_cvda = response.intercom_cvda;
    this.createable = response.createable;
    this.updateable = response.updateable;
    this.builtIn = response.built_in || false;
  }

  get intercomFieldType(): IntercomFieldType {
    return 'conversation';
  }

  get synchronized() {
    return this.builtIn || isPresent(this.intercom_cvda?.id);
  }

  get intercomCvdaIdentifier() {
    return this.intercom_cvda?.id;
  }

  get intercomAttributeDescriptorIcon() {
    switch (this.type) {
      case 'boolean':
      case 'checkbox':
        return 'boolean';
      case 'integer':
      case 'decimal':
      case 'double':
        return 'numbers';
      case 'datetime':
      case 'date':
        return 'calendar';
      case 'picklist':
      case 'dropdown':
      case 'multiselect':
      case 'priority':
      case 'tickettype':
        return 'list';
      default:
        return 'small-text';
    }
  }

  get intercomDataType() {
    switch (this.type) {
      case 'boolean':
      case 'checkbox':
        return 'boolean';
      case 'integer':
        return 'integer';
      case 'decimal':
      case 'double':
        return 'float';
      case 'datetime':
      case 'date':
        return 'date';
      case 'picklist':
      case 'dropdown':
      case 'multiselect':
      case 'priority':
      case 'tickettype':
        return 'conversation_attribute_list';
      default:
        return 'string';
    }
  }
}
